import { View } from './view'

export const Team = View
